<template>
  <div class="p-suggest-panel__wrap">
    <VueSimpleSuggest
      v-model="query"
      display-attribute="label"
      value-attribute="id"
      :styles="styles"
      :destyled="true"
      :list="getSuggestionList"
      :min-length="3"
      :debounce="200"
    >
      <slot></slot>

      <template #suggestion-item="{ suggestion }">
        <span class="p-suggest-panel__suggest_item__label">
          {{ suggestion.label }}
        </span>
        <span v-if="suggestion.id" class="p-suggest-panel__suggest_item__id"
          >ID: {{ suggestion.id }}</span
        >
      </template>
    </VueSimpleSuggest>
  </div>
</template>

<script lang="ts">
import axios from "axios";
//import VueSimpleSuggest from "vue-simple-suggest";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    value: { type: String, required: true },
    type: { type: String, required: true }
  },
  components: {
    //VueSimpleSuggest
  }
})
export default class SuggestPanel extends Vue {
  value!: string;
  type!: string;
  query = "";
  styles: Record<string, any> = {
    vueSimpleSuggest: "p-suggest-panel",
    inputWrapper: "p-suggest-panel__input_wrapper",
    suggestions: "p-suggest-panel__suggestions",
    suggestItem: "p-suggest-panel__suggest_item"
  };

  getSuggestionList() {
    //const self = this;
    const postData = {
      query: this.value,
      type: this.type
    };

    return axios
      .post("/api/admin/suggest/", postData)
      .then((response) => response.data)
      .catch((error) => {
        // TODO: エラー対応
      });
  }
}
</script>

<style lang="scss">
.p-suggest-panel {
  width: 100%;

  &__wrap {
    position: relative;
  }

  &__suggestions {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 100%;
    max-width: 100%;
    min-width: 240px;
    margin-top: rem(8);
    border: px(1) solid #bdbdbd;
    box-shadow: 0px rem(5) rem(12) rgba(0, 0, 0, 0.22);
    border-radius: rem(4);
    overflow: hidden;
    background: #ffffff;
  }

  &__suggest_item {
    padding: rem(12) rem(10) rem(13) rem(10);
    display: flex;
    cursor: pointer;

    &.hover {
      background: rgba(240, 240, 240, 0.43);
    }

    &__label {
      color: $common-black;
      font-size: rem(14);
    }
    &__id {
      color: $common-gray500;
      font-size: rem(12);
      margin-left: auto;
      margin-right: 0;
      padding-left: rem(16);
    }
  }
}
</style>
